import className from 'classnames';
import React from 'react';
import './ButtonGroup.scss';

interface IButtonGroupProps {
  /**
   * Defines how button groups are aligned in their flex container
   * when more width is provided than is required for the buttons (left by default)
   */
  align?: 'left' | 'center' | 'right';
}

const ButtonGroup: React.FC<React.PropsWithChildren<IButtonGroupProps>> = ({ children, align = 'left' }) => (
  <div
    className={className(
      'ButtonGroup',
      { 'ButtonGroup-center': align === 'center' },
      { 'ButtonGroup-right': align === 'right' }
    )}
  >
    {children}
  </div>
);

export { ButtonGroup };
